export default __webpack_public_path__ + "static/media/pulse.4d92f6b4.png";